import { Divider } from 'antd';

function App({ item, amount }) {
  return (
    <Divider style={{ borderColor: 'rgba(255,255,255,0.05)', marginTop: '24px', marginBottom: '24px' }} />
  );
}

export default App;
